<h3 class="category-block__title">
  <ng-content select="header"></ng-content>
</h3>
<div class="category-block__sections">
  <ng-content select="ui-category-block-header-control"></ng-content>
</div>
<ng-content></ng-content>
<ui-btn-entity-create *ngIf="isShowCreateButton" (click)="onCreate()"></ui-btn-entity-create>
